<template>
  <div ref="bgSetWrap">
    <div class="content-item">
      <div class="verticallyCenter">
        <span class="fs14 flex1">{{ displayTitle }}</span>
        <el-dropdown @command="handleCommand" trigger="click" v-if="hasAddBtn">
          <span class="el-dropdown-link icon-portal-plus" :class="bgDropdownList.length === 0 ? 'disabled' : ''"></span>
          <el-dropdown-menu slot="dropdown">
            <el-dropdown-item v-for="(list, index) in bgDropdownList" :key="'bgdrop_' + index" :command="list.type">{{
              list.label
            }}</el-dropdown-item>
          </el-dropdown-menu>
        </el-dropdown>
      </div>
    </div>
    <!-- 此div不能删除，用于快捷菜单打开资源库 -->
    <div style="display: none" class="default-image" @click.stop="handleCommand('img', '', true)"></div>
    <div v-for="(bg, index) in backgroundVal" :key="'bg_' + index" class="bg-style-list mt8" :class="{'is-color-picker': bg.type === 'color'}">
      <div v-if="bg.type === 'img'" class="bg-scan" @click.stop="handleCommand(bg.type, 'edit')">
        <img :src="bg.imgUrl" class="img-icon" alt="" />
        <span class="color-text">图片</span>
        <span class="icon-portal-delete right-handle-icon" @click.stop="delBgSet(index)"></span>
      </div>
      <div v-if="bg.type === 'video'" class="bg-scan" @click.stop="handleCommand(bg.type, 'edit')">
        <img :src="bgVideo.imgUrl || defaultVideoBg" class="img-icon mr8" alt="" />
        <span class="color-text">视频</span>
        <span class="icon-portal-delete right-handle-icon" @click.stop="delBgSet(index)"></span>
      </div>
      <div v-if="bg.type === 'linearGradient'" class="bg-scan" @click.stop="handleCommand(bg.type, 'edit')">
        <span class="color-scan linearGradient-span" :style="getLinearGradient(bg.data)"></span>
        <span class="color-text">线性渐变</span>
        <span class="icon-portal-delete right-handle-icon" @click.stop="delBgSet(index)"></span>
      </div>
      <div v-if="bg.type === 'radialGradient'" class="bg-scan" @click.stop="handleCommand(bg.type, 'edit')">
        <span class="color-scan radialGradients-span" :style="getRadialGradient(bg.data)"></span>
        <span class="color-text">径向渐变</span>
        <span class="icon-portal-delete right-handle-icon" @click.stop="delBgSet(index)"></span>
      </div>
    </div>
    <div v-for="(bg, index) in backgroundVal" :key="index">
      <cx-color-picker
        v-if="bg.type === 'color'"
        class="color-picker-containe mt8"
        :isThemeColor.sync="bg.isThemeColor"
        :config.sync="bgColor"
        colorType="string"
      />
    </div>
    <!-- 图片设置改成v-show 用于快捷菜单点击设置背景图-->
    <div class="bg-set-dialog-wrap padding12" @click.stop="closebgSetStatu" v-show="showBgSetDialog">
      <!-- 图片设置 -->
      <div class="bg-set-dialog" @click.stop v-show="showBgSetArr.showImgSet && bgImage">
        <img-upload :imgSrc.sync="bgImage.imgUrl" :imgType="imgType" />
        <img-crop-bg
          class="mt16"
          :clipSize.sync="bgImage.clipSize"
          :repeatType.sync="bgImage.repeatType"
          :alignType.sync="bgImage.alignType"
        />
      </div>
      <!-- 视频设置 -->
      <div class="bg-set-dialog" @click.stop v-if="showBgSetArr.showVideoSet && bgVideo">
        <div class="source-type">
          <el-radio v-model="bgVideo.videoCache" :label="true">本地上传</el-radio>
          <el-radio v-model="bgVideo.videoCache" :label="false">视频地址</el-radio>
        </div>
        <div v-show="bgVideo.videoCache" class="video-source-box">
          <div class="video-bgcard">
            <div class="uploadfailed" v-if="percentage == 'error'">
              <i class="icon-portal-attention"></i>
              <p class="text">上传失败</p>
            </div>
            <div class="uploading" v-else-if="percentage > 0">
              <el-progress
                type="circle"
                :percentage="percentage"
                :width="36"
                :show-text="false"
                :color="themeColor"
              ></el-progress>
              <p class="text">{{ percentage }}%</p>
            </div>
            <img :src="bgVideo.imgUrl || defaultVideoBg" alt="" v-else />
          </div>
          <div class="video-upload-box">
            <p class="tips">格式：FIV、MP4<br />大小：2G以下</p>
            <el-upload
              name="file"
              action="https://pan-yz.chaoxing.com/upload"
              accept=".mp4,.m3u8"
              :data="actionData"
              list-type="picture-card"
              :on-preview="handlePictureCardPreview"
              :on-success="handleSuccessHandle"
              :on-error="handleFailHandle"
              :on-progress="handleProgressHandle"
              :show-file-list="false"
            >
              <button class="video-upload-btn">点击上传</button>
            </el-upload>
          </div>
          <el-checkbox class="mt12" v-model="bgVideo.loopPlay">循环播放</el-checkbox>
          <el-checkbox class="mt12" v-model="bgVideo.autoplay">自动播放</el-checkbox>
        </div>
        <div v-show="!bgVideo.videoCache" class="dataUrl-item mb16 video-upload-ipt">
          <el-input type="text" class="mb8" v-model="bgVideo.imgUrl" placeholder="请输入https://开头的地址"></el-input>
        </div>
      </div>
      <!-- 线性渐变设置 -->
      <div class="bg-set-dialog" @click.stop v-if="showBgSetArr.showLinearGradientSet && bgLinearGradient">
        <cx-bgColor :data.sync="bgLinearGradient.data" />
      </div>
      <!-- 径向渐变设置 -->
      <div class="bg-set-dialog" @click.stop v-if="showBgSetArr.showRadialGradientSet && bgRadialGradient">
        <cx-bgColor :data.sync="bgRadialGradient.data" gradientType="radial" />
      </div>
    </div>
  </div>
</template>

<script>
import default_video_fm from "assets/images/image_placeholder.png"
import complexSetMixin from "./complexSetMixin.js"
import cxColorPicker from "./cxColorPicker.vue"
import { produce } from "immer"
export default {
  mixins: [complexSetMixin()],
  components: {
    cxColorPicker
  },
  name: "cxBackground",
  props: {
    defaultValue: undefined,
    extraConfig: undefined,
    config: undefined,
    background: {
      type: null,
      required: false
    },
    imgType: {
      type: [Number, String],
      required: false,
      default: 10
    },
    hasAddBtn: {
      type: Boolean,
      default: true
    },
    infoTips: {
      type: String,
      default: "背景",
      required: false
    },
    options: {
      type: Object,
      required: false
    },
    showVideo: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      this1: this,
      // configData: JSON.parse(JSON.stringify(this.config || this.defaultValue)),
      showBgSetDialog: false,
      showBgSetArr: {
        showImgSet: false,
        showVideoSet: false,
        showLinearGradientSet: false,
        showRadialGradientSet: false
      },
      defaultImg: {
        type: "img",
        label: "图片",
        imgUrl: "",
        clipSize: "cover",
        repeatType: "no-repeat",
        alignType: "center center",
        opacity: 100
      },
      defaultLinearGradient: {
        type: "linearGradient",
        label: "线性渐变",
        data: {
          angle: 20,
          stops: [
            ["rgba(255,255,255,0.5)", 0, { isThemeColor: false, colorOpacity: 100, themeColorId: 0 }],
            ["rgba(255,255,255,1)", 1, { isThemeColor: false, colorOpacity: 100, themeColorId: 0 }]
          ]
        },
        isThemeColor: false,
        colorOpacity: 100,
        themeColorId: 0
      },
      defaultRadialGradient: {
        type: "radialGradient",
        label: "径向渐变",
        data: {
          siteX: 50,
          siteY: 50,
          stops: [
            ["rgba(255,255,255,0.5)", 0, { isThemeColor: false, colorOpacity: 100, themeColorId: 0 }],
            ["rgba(255,255,255,1)", 1, { isThemeColor: false, colorOpacity: 100, themeColorId: 0 }]
          ]
        },
        isThemeColor: false,
        colorOpacity: 100,
        themeColorId: 0
      },
      defaultVideo: {
        type: "video",
        label: "视频",
        imgUrl: "",
        videoCache: true,
        loopPlay: true,
        autoplay: true
      },
      percentage: 0,
      actionData: {},
      before: null,
      defaultVideoBg: default_video_fm,
      videoItemIndex: null
    }
  },
  watch: {
    // backgroundVal: {
    //   handler(newVal, oldVal) {
    //     if (newVal.length !== oldVal.length) {
    //       this.$emit("update:config", newVal)
    //     } else if (newVal.length === 1 && oldVal.length === 1 && newVal[0].type === 'color' && oldVal[0].type === 'color') {
    //       newVal[0].color !== oldVal[0].color  && this.$emit("update:config", newVal)
    //     } else {
    //       this.$emit("update:config", newVal)
    //     }

    //   },
    //   deep: true
    // },
    ids: {
      handler(val) {
        this.showBgSetDialog = false
      },
      deep: true
    }
  },
  computed: {
    displayTitle() {
      return this.extraConfig?.title || this.infoTips
    },
    ids() {
      return this.$store.state.states.activeID
    },
    bgColor: {
      get() {
        const colorSet = this.backgroundVal.find(item => item.type === "color")
        return colorSet
      },
      set(newVal, oldVal) {
        const colorIndex = this.backgroundVal.findIndex(item => item.type === "color")
        this.backgroundVal = produce(JSON.parse(JSON.stringify(this.backgroundVal)), draft => {
          draft[colorIndex] = newVal
        })
      }
    },
    themeColor() {
      return this.$store.state[this.request_prefix].page.themeColor
    },
    bgImage() {
      const self = this
      let img, index
      for (let i = 0; i < this.backgroundVal.length; i++) {
        if (this.backgroundVal[i].type === "img") {
          img = this.backgroundVal[i]
          index = i
          break
        }
      }
      if (!img) {
        // 兼容数据为空的情况不报错
        img = this.defaultImg
      }
      return new Proxy(
        {},
        {
          get(target, key) {
            return img[key]
          },
          set(target, key, value) {
            self.backgroundVal = produce(self.backgroundVal, draft => {
              draft[index] = { ...draft[index], [key]: value }
            })
            return true
          }
        }
      )
    },
    bgVideo() {
      let video
      for (let i = 0; i < this.backgroundVal.length; i++) {
        if (this.backgroundVal[i].type === "video") {
          this.videoItemIndex = i
          video = this.backgroundVal[i]
          break
        }
      }
      return video
    },
    bgLinearGradient: {
      get() {
        const self = this
        let tmpObj, index
        for (let i = 0; i < this.backgroundVal.length; i++) {
          if (this.backgroundVal[i].type === "linearGradient") {
            tmpObj = this.backgroundVal[i]
            index = i
            break
          }
        }
        if (!tmpObj) return {data: []}
        const obj = Object.create(null)
        Object.defineProperty(obj, "data", {
          get() {
            return tmpObj.data
          },
          set(val) {
            self.backgroundVal = produce(self.backgroundVal, draft => {
              draft[index] = { ...tmpObj, data: val }
            })
          }
        })
        return obj
      }
    },
    bgRadialGradient: {
      get() {
        const self = this
        let tmpObj, index
        for (let i = 0; i < this.backgroundVal.length; i++) {
          if (this.backgroundVal[i].type === "radialGradient") {
            tmpObj = this.backgroundVal[i]
            index = i
            break
          }
        }
        if (!tmpObj) return {data: []}
        const obj = Object.create(null)
        Object.defineProperty(obj, "data", {
          get() {
            return tmpObj.data
          },
          set(val) {
            self.backgroundVal = produce(self.backgroundVal, draft => {
              draft[index] = { ...tmpObj, data: val }
            })
          }
        })
        return obj
      }
    },
    bgDropdownList() {
      let list = []
      if (!Array.isArray(this.backgroundVal)) return []
      let defaultList = [
        { type: "img", label: "图片" },
        { type: "linearGradient", label: "线性渐变" },
        { type: "radialGradient", label: "径向渐变" }
      ]
      // 目前针对通栏，可以添加视频背景
      if (this.showVideo) {
        defaultList.splice(1, 0, { type: "video", label: "视频" })
      }
      this.backgroundVal.forEach(item => {
        for (let i = 0; i < defaultList.length; i++) {
          if (defaultList[i].type === item.type) {
            defaultList.splice(i, 1)
            break
          }
        }
      })
      return defaultList
    },
    backgroundVal: {
      get() {
        return JSON.parse(JSON.stringify(this.configData || []))
      },
      set(val) {
        this.$emit("update:config", val)
      }
    },
    getLinearGradient() {
      return function (params) {
        let tmp = []
        params.stops.forEach(item => {
          tmp.push(item[0] + " " + item[1] * 100 + "%")
        })
        return "background-image:linear-gradient(" + params.angle + "deg," + tmp.join(",") + ")"
      }
    },
    getRadialGradient() {
      return function (params) {
        let tmp = []
        params.stops.forEach(item => {
          tmp.push(item[0] + " " + item[1] * 100 + "%")
        })
        return "background-image:radial-gradient(at " + params.siteX + "% " + params.siteY + "%," + tmp.join(",") + ")"
      }
    }
  },
  mounted() {
    document.getElementById("app").addEventListener("click", this.hidder, true)
  },
  beforeDestroy() {
    document.getElementById("app").removeEventListener("click", this.hidder, true)
  },
  methods: {
    hidder(e) {
      let ele = this.$refs.bgSetWrap
      if (ele && ele.contains(e.target)) {
        return
      } else {
        this.showBgSetDialog = false
      }
    },
    handleCommand(command, type, hideBgSet) {
      let name = command[0].toUpperCase() + command.substr(1, command.length - 1)
      if (!hideBgSet) this.showBgSetDialog = true
      let defaultData = "default" + name
      if (name == "Video") {
        this.getUrl()
      }
      if (type !== "edit" && this[defaultData]) {
        this.backgroundVal = produce(JSON.parse(JSON.stringify(this.backgroundVal)), draft => {
          draft.unshift(JSON.parse(JSON.stringify(this[defaultData])))
        })
        // this.backgroundVal.unshift(JSON.parse(JSON.stringify(this[defaultData])))
      }
      for (let key in this.showBgSetArr) {
        this.showBgSetArr[key] = "show" + name + "Set" == key ? true : false
      }
    },
    closebgSetStatu() {
      this.showBgSetDialog = undefined
    },
    delBgSet(index) {
      this.backgroundVal = produce(JSON.parse(JSON.stringify(this.backgroundVal)), draft => {
        draft.splice(index, 1)
      })
      // his.backgroundVal.splice(index, 1)
      this.$forceUpdate()
    },
    handlePictureCardPreview(file) {},
    handleProgressHandle(response, file) {
      this.percentage = parseInt(file.percentage)
    },
    handleSuccessHandle(response, file, fileList) {
      if (response.result) {
        this.percentage = 0
        this.bgVideo.imgUrl = response.data.thumbnail
        this.bgVideo.objectId = response.objectId
        this.backgroundVal = produce(JSON.parse(JSON.stringify(this.backgroundVal)), draft => {
          draft.splice(this.videoItemIndex, 1, this.bgVideo)
        })
        // this.backgroundVal.splice(this.videoItemIndex, 1, this.bgVideo)
        this.showBgSetDialog = false
      } else {
        this.percentage = "error"
      }
    },
    handleFailHandle(err, file, fileList) {},
    async getUrl() {
      let token = await this.getToken()
      // let token = "68a97b6e89af8ed91398035f530c4155"
      let uid = await this.getUid()
      this.actionData = {
        uploadtype: "normal",
        puid: uid,
        _from: "cdmh",
        _token: token
      }
    },
    // 获取uid
    getUid() {
      let userInfo = this.$store.state.states.userInfo
      if (userInfo) {
        return userInfo.uid
      }
      return new Promise((resolve, reject) => {
        this.$API.getUserInfo().then(res => {
          if (res.data.code === 1) {
            resolve(res.data.data.uid)
          } else {
            reject("err")
          }
        })
      })
    },
    // 获取token
    getToken() {
      return new Promise((resolve, reject) => {
        this.instance.get("usts/yunpan/uservalid").then(res => {
          if (res.status == 200) {
            console.log("res token:>>", res)
            resolve(res.data)
          } else {
            reject("err")
          }
        })
      })
    }
  }
}
</script>

<style scoped lang="scss">
.bg-color-set {
  border: none;
  background: var(--inputBg);
}
.padding12 {
  padding: 12px;
  box-sizing: border-box;
}
.bg-set-dialog-wrap {
  position: fixed;
  top: 0;
  right: 0;
  width: 260px;
  bottom: 0;
  background: var(--dialogShade);
  z-index: 9999;
}
.bg-set-dialog {
  position: absolute;
  top: 50%;
  right: 0;
  width: 260px;
  padding: 12px;
  transform: translateY(-50%);
  background: var(--leftMenuBgColor);
  border: 1px solid var(--borderColorFour);
  box-sizing: border-box;
  box-shadow: 0 6px 16px -8px rgba(0, 0, 0, 0.08), 0 9px 28px rgba(0, 0, 0, 0.05), 0 12px 48px 16px rgba(0, 0, 0, 0.03);
  border-radius: 4px;
}
.bg-style-list.is-color-picker > div {
  padding: 0;
}
.bg-style-list {
  > div:not(:last-child) {
    margin-bottom: 8px;
  }
  > div {
    display: flex;
    cursor: pointer;
    position: relative;
    font-size: 14px;
    border-radius: 4px;
    height: 32px;
    padding: 0 0;
    //border: 1px solid var(--borderColorFour);
    background-color: var(--inputBg);
    align-items: center;
    &:hover {
      background-color: var(--inputNuberHoverThemeBgColor);
      .right-handle-icon {
        display: inline-block;
      }
    }
    &.active {
      border-color: var(--themeColor);
      background-color: var(--dialogBgColor);
    }
  }
  .img-icon,
  .color-scan {
    display: inline-block;
    border-radius: 4px;
    width: 20px;
    height: 20px;
    vertical-align: middle;
    margin-right: 4px;
  }
  .icon-portal-delete {
    font-size: 15px;
  }
}
.el-dropdown-link {
  display: inline-block;
  width: 24px;
  height: 24px;
  line-height: 24px;
  text-align: center;
  border-radius: 4px;
  color: var(--themeColor);
  &:hover {
    background-color: var(--iconHoverBgColor);
  }
  &.disabled {
    color: var(--themeColorDisabled);
    &:hover {
      background-color: transparent;
    }
  }
}
//上传视频的弹框样式
.bg-set-dialog .source-type label {
  margin-right: 20px;
}
.video-bgcard {
  display: inline-block;
  vertical-align: top;
  width: 90px;
  height: 90px;
  border: 1px solid var(--sliderBackGround);
  box-sizing: border-box;
  border-radius: 4px;
  overflow: hidden;
}
.video-bgcard > img {
  width: 100%;
  height: 100%;
}
.video-upload-box {
  display: inline-block;
  vertical-align: top;
  margin-left: 16px;
  width: calc(100% - 112px);
}
.video-upload-box .tips {
  margin-bottom: 26px;
  font-size: 12px;
  line-height: 17px;
  color: var(--subTextColor);
}

.video-upload-box ::v-deep .el-upload--picture-card {
  width: 80px;
  height: 28px;
  line-height: 28px;
  border: none;
  background: none;
}
.video-upload-btn {
  width: 80px;
  height: 28px;
  border: 1px solid var(--themeColor);
  box-sizing: border-box;
  border-radius: 4px;
  color: var(--themeColor);
  font-size: 14px;
  line-height: 20px;
  background: transparent;
}
.video-source-box {
  margin-top: 8px;
}

.video-upload-ipt {
  margin-top: 8px;
}
.uploading {
  width: 100%;
  height: 90px;
  background: var(--dataAddActiveBgColor);
  text-align: center;
  padding: 16px 0;
}
.uploading .text {
  font-weight: 600;
  font-size: 14px;
  color: var(--themeColor);
  margin-top: 8px;
  line-height: 20px;
}
.uploadfailed {
  width: 100%;
  height: 100%;
  background: rgba(255, 78, 78, 0.08);
  border: 1px solid #e9e9e9;
  text-align: center;
  color: #ff4e4e;
  padding: 15px;
  font-size: 16px;
}
.uploadfailed .text {
  font-size: 14px;
  line-height: 20px;
}
</style>
